const octoAsync = async function (
    currUrl,
    currMethod,
    currHeaders,
    currData = ''
  ) { 
    let response
    if (currData !== '') {
        response = await fetch(`${currUrl}`, {
            method: currMethod,
            body: JSON.stringify(currData),
            headers: currHeaders,
        })
    } else {
        response = await fetch(`${currUrl}`, {
            method: currMethod,
            headers: currHeaders,
        })
    }
    const responseJSON = await response.json()
    return responseJSON
}

function waitForElement(selector, callback) {
    const element = document.querySelector(selector);
    if (element) {
        callback(element);
        return;
    }

    const observer = new MutationObserver((mutations) => {
        const element = document.querySelector(selector);
        if (element) {
            observer.disconnect();
            callback(element);
        }
    });

    observer.observe(document.documentElement, {
        childList: true,
        subtree: true
    });
}

function assingNewAbbreviationMount(current_state_abbreviation){
    if(current_state_abbreviation != null){
        const option = document.querySelector(`#free-shipping-states option[value="${current_state_abbreviation}"]`);
        if (option) {
            const amount = option.dataset.amount;
            localStorage.setItem("current_state_abbreviation_amount", amount);
        }else{
            localStorage.removeItem("current_state_abbreviation_amount");
            setTimeout(function(){
                $(".custom-free-shipping-bar").remove();
            },1100);
        }
    }else{
        setTimeout(function(){
            $(".custom-free-shipping-bar").remove();
        },1100);
    }
}

/* OctoCode */
function avaliableForPickupMessage() {
    if (hasPickupTag) {
        let currVariant = $("variant-picker fieldset input:checked").val() || $(".text-block--ANFJON0gzbnV1bURSL__product_title_eYVzTU.h1 p").text().toLowerCase();
        if (!currVariant) return;
        $(`form[data-type='add-to-cart-form'] input[name="properties[Pickup]"]`).remove();
        if (currVariant.includes("15-gal") || currVariant.includes("15 gallons") || currVariant.includes("15gallons")) {
            $(".pickup-warning").show();
            $(`form[data-type='add-to-cart-form']`).append(`<input type="hidden" name="properties[Pickup]" value="item only available for pickup">`);
        } else {
            $(".pickup-warning").hide();
        }
    }
}
/* End OctoCode */

function gerCurrentMountState(current_state_abbreviation){
   if(current_state_abbreviation){
        const option = document.querySelector(`#free-shipping-states option[value="${current_state_abbreviation}"]`);
        if (option) {
            const amount = option.dataset.amount;
            return amount;
        }
    }
}
        

function customBarFreeShipping(el, current_state_abbreviation_amount){

    $(".custom-free-shipping-bar").remove();

    if(current_state_abbreviation_amount){
        let cart_total_liquid = $(`text-component[ref="cartTotal"]`).text().trim() ;
         
        cart_total_liquid = cart_total_liquid.replace(/[^0-9.,-]/g, "");
        cart_total_liquid = cart_total_liquid.replace(/,/g, "");
        cart_total_liquid = parseFloat(cart_total_liquid);
    
        let percentWidth = (cart_total_liquid / current_state_abbreviation_amount) * 100;
        if (percentWidth >= 95 && percentWidth < 100) {
            percentWidth = 95;
        }

        if (percentWidth >= 100) {
            percentWidth = 100;
        }
        percentWidth = percentWidth >= 100 ? 100 : percentWidth;
        if(cart_total_liquid){
            $(`${el}`).before(`<div class="custom-free-shipping-bar">
                <div class="custom-free-shipping-bar__header">
                    <div>
                    Shipping
                    </div>
                    <div class="${cart_total_liquid >= current_state_abbreviation_amount ? `custom-green-color-bar`: ``}">
                        ${cart_total_liquid >= current_state_abbreviation_amount ? `Free`: `$${current_state_abbreviation_amount}`}
                    </div>
                </div>
                <div class="custom-free-shipping-bar__content">
                    <div>
                        <div></div>
                        <div style="width:${percentWidth}%" class="${cart_total_liquid >= current_state_abbreviation_amount ? `custom-green-bg-bar`: ``}"></div>
                    </div>
                    <div class="${cart_total_liquid >= current_state_abbreviation_amount ? `custom-green-color-bar`: ``}">
                        Free Shipping
                    </div>
                </div>
                <div class="custom-free-shipping-bar__footer">
                    <div class="${cart_total_liquid >= current_state_abbreviation_amount ? `custom-orange-color-bar`: `custom-orange-color-bar`}">
                        ${cart_total_liquid >= current_state_abbreviation_amount ? `🎉Enjoy your FREE SHIPPING🥳`: `✨✨Add $${(current_state_abbreviation_amount - cart_total_liquid).toFixed(2) } to get FREE SHIPPING`}
                    </div>
                </div>
            </div>`);
        }
    }
}

if($("body.cart").length == 0){
    waitForElement(".wow-cart-product-details-box", function() {
        setTimeout(function(){
            $(`.wow-cart-product-details-box`).before(`<div class="custom-free-shipping-bar-announce">
                <a href="/cart">Click “Go to Cart” (bottom left) to check free shipping</a>
            </div>`);
        }, 300);
    });
}


waitForElement("body.cart", function() {
    setTimeout(function(){
        customBarFreeShipping(".cart-items__wrapper", localStorage.getItem("current_state_abbreviation_amount"));
    }, 1000);
});

var hasPickupTag ;


const showHideInfo = function () {
    if ($("body.product .product-details").length > 0) {
        
        const current_state = localStorage.getItem("current_state");
        const normalizedState = current_state?.toLowerCase().replace(/\s+/g, '-') || '';
        const productData = document.getElementById("product-data");
        const tagsRaw = productData?.dataset?.tags || ""; // ✅ evita crash si no existe
        const productTags = tagsRaw
            .split(",")
            .map((tag) => tag.trim())
            .filter(Boolean);

        const noTags = productTags.filter(tag => tag.startsWith('no-'));
        const onlyTags = productTags.filter(tag => tag.startsWith('only-') && tag !== 'only-pickup');
        hasPickupTag = productTags.includes('only-pickup');
        const hasFreeShippingTag = productTags.includes('free-shipping');

        const hasBlockedState = noTags.includes('no-' + normalizedState);
        const isOnlyTagMismatch = onlyTags.length > 0 && !onlyTags.includes('only-' + normalizedState);
        const shouldBlock = hasBlockedState || isOnlyTagMismatch;

        const selectorsToHide = [
            '.product-form-buttons .shopify-payment-button',
            '.product-form-buttons .add-to-cart-button',
            '.product-form-buttons .quantity-selector'
        ];
        const selectorsDisabledButton = [
            '.product-form-buttons .add-to-cart-button'
        ];
        const form = document.querySelector('form[action*="/cart/add"].shopify-product-form');

        const warningBox = document.getElementById("state-warning");
        const warningError = document.getElementById("state-warning-error");
        const warningLink = document.getElementById("state-warning-link");
        const pickupBox = document.getElementById("pickup-warning");

        // Limpiar inputs anteriores
        form?.querySelectorAll('input[name^="properties[N"], input[name^="properties[ONLY"], input[name^="properties[Pickup"]').forEach(input => input.remove());

        // Limpiar mensajes
        if (warningBox) {
            warningBox.style.display = "none";
            if (warningError) warningError.innerHTML = '';
            if (warningLink) warningLink.innerHTML = '';
        }
        if (pickupBox) {
            pickupBox.style.display = "none";
        }

        if (form) {

            
            // no-estado
            noTags.forEach((tag, index) => {
                const stateName = tag.replace(/^no-/, '').replace(/-/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
                const input = document.createElement("input");
                input.type = "hidden";
                input.name = `properties[NO${index + 1}]`;
                input.value = `item does not ship to ${stateName}`;
                form.appendChild(input);
            });

            // only-estado
            onlyTags.forEach((tag, index) => {
                const stateName = tag.replace(/^only-/, '').replace(/-/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
                const input = document.createElement("input");
                input.type = "hidden";
                input.name = `properties[ONLY${index + 1}]`;
                input.value = `item only available for ${stateName}`;
                form.appendChild(input);
            });

            // only-pickup
            if (hasPickupTag) {
                const input = document.createElement("input");
                input.type = "hidden";
                input.name = `properties[Pickup]`;
                input.value = `item only available for pickup`;
                form.appendChild(input);

                // Mostrar mensaje separado
                if (pickupBox) {

                    let currVariant = $("variant-picker fieldset input:checked").val() || 
                        $(".text-block--ANFJON0gzbnV1bURSL__product_title_eYVzTU.h1 p").text().toLowerCase() || 
                        $(".text-block--ASjByeVVIemdKN25pb__product_title_eYVzTU.h1 p").text().toLowerCase() ;

                    console.log(currVariant)
                    if (currVariant.includes("15-gal") || currVariant.includes("15 gallons") || currVariant.includes("15gallons") || currVariant.includes("25-gal") || currVariant.includes("25 gallons") || currVariant.includes("25gallons")){
                        pickupBox.style.display = 'block';
                    }
                }
            }

            // ✅ FREE SHIPPING — NUEVO BLOQUE
            if (hasFreeShippingTag) {
                const input = document.createElement("input");
                input.type = "hidden";
                input.name = `properties[FreeShipping]`;
                input.value = `Free shipping available`;
                form.appendChild(input);
            }
        }

        // Mostrar advertencia por estado (no- o only-)
        if (shouldBlock) {
            if (warningBox && warningError && warningLink) {
                warningError.innerHTML = `
                <img src="https://cdn.shopify.com/s/files/1/0014/1377/5433/files/Icons-29.webp?v=1758653326" alt="alert" />
                <b>This item does not ship to ${current_state}</b>
                `;
                warningLink.innerHTML = `
                <b>Not in <span>${current_state}</span>?</b> <a class="go-to-location" href="#">Set your location</a>
                `;
                warningBox.style.display = 'block';
            }

            selectorsToHide.forEach(selector => {
                document.querySelectorAll(selector).forEach(el => el.style.display = 'none');
            });
            selectorsDisabledButton.forEach(selector => {
                document.querySelectorAll(selector).forEach(button => button.disabled = true);
            });
        } else {
            selectorsToHide.forEach(selector => {
                document.querySelectorAll(selector).forEach(el => el.style.display = '');
            });
            selectorsDisabledButton.forEach(selector => {
                document.querySelectorAll(selector).forEach(button => button.disabled = false);
            });
        }
    }
};



const loadErrorContent = function(currState){
    $("#state-warning-error").html(`
        <img src="https://cdn.shopify.com/s/files/1/0014/1377/5433/files/Icons-29.webp?v=1758653326" alt="alert" width="" height=""/>
        <b>This item does not ship to ${currState}</b><br />
    `);
    if(currState){
        $("#state-warning-error").addClass("active")
    }else{
        $("#state-warning-error").removeClass("active")
    }
    $("#state-warning-link").html(`
        <b>Not in <span>${currState}</span>?</b> <a class="go-to-location"  href="#">Set your location</a>
    `);
}


const COOLDOWN_MS = 5 * 60 * 1000;
const LS_KEY = "ipapi_last_run_ms";

async function runIpApiWithCooldown() {
  const now = Date.now();
  const lastRun = Number(localStorage.getItem(LS_KEY) || 0);

  // Si ya corrió hace menos de 5 min, no hagas nada
  if (lastRun && (now - lastRun) < COOLDOWN_MS) return;

  // Marca que va a correr AHORA (evita que el observer dispare 20 veces seguidas)
  localStorage.setItem(LS_KEY, String(now));

  try {

    const headers = { "Content-type": "application/json" };
    const response = await octoAsync(`https://ipapi.co/json`, `GET`, headers, ``);

    if (response?.region) {
      $(".custom-tooltip-trigger small.state-n").text(`Shipping to: ${response.region}`);
      localStorage.setItem("current_state", response.region);

      const abbr = response?.places?.[0]?.["state abbreviation"];

      if (abbr) {
        localStorage.setItem("current_state_abbreviation", abbr);
        assingNewAbbreviationMount(abbr);
      } else {
        localStorage.removeItem("current_state_abbreviation");
      }

      showHideInfo();
      loadErrorContent(response.region);

      // usa la misma abbr que ya validaste
      customBarFreeShipping(".cart-items__wrapper", gerCurrentMountState(abbr));
    }
  } catch (err) {
    // Si falló, puedes permitir reintento inmediato
    localStorage.removeItem(LS_KEY);
    console.error("ipapi error:", err);
  }
}

const getCurrentLocationLoad = async function () {
    //$(".custom-tooltip-trigger").removeClass("active");
    const current_state = localStorage.getItem("current_state");
    if(current_state){
        $(".custom-tooltip-trigger small.state-n").text(`Shipping to: ${current_state}`);
        //$(".custom-tooltip-trigger").addClass("active");
        showHideInfo();
        loadErrorContent(current_state);
    }else{
        runIpApiWithCooldown();
    }
    
}

// ✅ Ahora detecta su contenedor automáticamente
const getCurrentLocationClick = async function (el) {
    const $container = el.closest('.custom-tooltip-trigger-container');
    el.text("Getting...");
    $container.find("#use-current-location, #save-my-location, .use-current-location, .save-my-location").prop("disabled", true);
    try{
        let headers = { 'Content-type': 'application/json' }
        let response = await octoAsync(`https://ipapi.co/json`, `GET`, headers, ``);
        if(response?.region){
            $(".custom-tooltip-trigger small.state-n").text(`Shipping to: ${response.region}`);
            localStorage.setItem("current_state", response.region);
            localStorage.setItem("current_state_abbreviation", response.places[0]["state abbreviation"]);
            let current_state = localStorage.getItem("current_state");
            let current_state_abbreviation = localStorage.getItem("current_state_abbreviation");
            el.text("Success");
            showHideInfo();
            loadErrorContent(response.region);
            setTimeout(function(){
                el.text("Use current location");
                $container.find("#use-current-location, #save-my-location, .use-current-location, .save-my-location").prop("disabled", false);
                $container.find('.custom-tooltip').fadeOut(200);
                $container.find("#new-zip, .new-zip").val("");
            }, 2000);
            customBarFreeShipping(".cart-items__wrapper", gerCurrentMountState(response.places[0]["state abbreviation"]));
            $("cart-drawer-component .custom-free-shipping-bar").remove();
        }else{
            localStorage.removeItem("current_state_abbreviation");
            $(".custom-free-shipping-bar").remove();
            $("cart-drawer-component .custom-free-shipping-bar").remove();
        }
    }catch(err){
        el.text("Location is not supported.");
        setTimeout(function(){
            el.text("Use current location");
            $container.find("#use-current-location, #save-my-location, .use-current-location, .save-my-location").prop("disabled", false);
        }, 2000);
        localStorage.removeItem("current_state_abbreviation");
        $(".custom-free-shipping-bar").remove();
        $("cart-drawer-component .custom-free-shipping-bar").remove();
    }
}

// ✅ También detecta contenedor y soporta id o clase del input
const saveCurrentLocation = async function (currCp, el) {
    const $container = el.closest('.custom-tooltip-trigger-container');
    el.text("Getting...");
    $container.find("#use-current-location, #save-my-location, .use-current-location, .save-my-location").prop("disabled", true);
    try{
        let headers = {
        'Content-type': 'application/json',
        }
        let response = await octoAsync(`/apps/zip/us/${currCp}`, `GET`, headers, ``);
        if(response?.places[0]?.state){
            $(".custom-tooltip-trigger small.state-n").text(`Shipping to: ${response?.places[0]?.state}`);
            localStorage.setItem("current_state", response?.places[0]?.state);
            if(response.places[0]["state abbreviation"]){
                localStorage.setItem("current_state_abbreviation", response.places[0]["state abbreviation"]);
                assingNewAbbreviationMount(response.places[0]["state abbreviation"]);
            }else{
                localStorage.removeItem("current_state_abbreviation");
            }
            let current_state = localStorage.getItem("current_state");
            let current_state_abbreviation = localStorage.getItem("current_state_abbreviation");
            el.text("Success");
            showHideInfo();
            loadErrorContent(response?.places[0]?.state);
            setTimeout(function(){
                el.text("Save my location");
                $container.find("#use-current-location, #save-my-location, .use-current-location, .save-my-location").prop("disabled", false);
                $container.find('.custom-tooltip').fadeOut(200);
                $container.find("#new-zip, .new-zip").val("");
            }, 2000);
            customBarFreeShipping(".cart-items__wrapper", gerCurrentMountState(response.places[0]["state abbreviation"]));
        }
    }catch(err){
        console.log(err)
        el.text("Error");
        setTimeout(function(){
            el.text("Save my location");
            $container.find("#use-current-location, #save-my-location, .use-current-location, .save-my-location").prop("disabled", false);
        }, 2000);
    }
    
}


$(function(){
    //AOS.init();
    const $input = $('#cmdk-input');
    const $wrapper = $(".predictive-search-form__content-wrapper");

    $input.on('focus', function() {
        $wrapper.addClass("active");
    });

    $input.on('input keydown', function() {
        $wrapper.addClass("active");
    });

    $input.on('blur', function() {
        setTimeout(() => {
            $wrapper.removeClass("active");
        }, 300);
    });
    
    isMobile = () => window.innerWidth < 750;
  
    // ✅ Soporta DIV#zip-form y/o FORM.zip-form y no interfiere entre mob/desk
    $(document).on('submit', '#zip-form, .zip-form', function (e) {
      e.preventDefault();
      const $container = $(this).closest('.custom-tooltip-trigger-container');
      const newZip = $container.find('#new-zip, .new-zip').val();
      $container.find('.custom-tooltip-trigger .zip').text(newZip);
      $container.find('.custom-tooltip').fadeOut(200);
    });

    // ✅ Enter dentro del input cuando sea DIV en lugar de FORM
    $(document).on('keydown', '#new-zip, .new-zip', function(e){
      if (e.key === 'Enter') {
        e.preventDefault();
        const $container = $(this).closest('.custom-tooltip-trigger-container');
        const newZip = $(this).val();
        $container.find('.custom-tooltip-trigger .zip').text(newZip);
        $container.find('.custom-tooltip').fadeOut(200);
      }
    });

    getCurrentLocationLoad();
    
    // Abre/cierra tooltip del contenedor clicado
    $(document).on("click", ".custom-tooltip-trigger", function(e){
      e.preventDefault();
      const $container = $(this).closest('.custom-tooltip-trigger-container');
      $container.find('.custom-tooltip').fadeToggle(150);
    });

    // Delegación por ID (funciona con elementos duplicados) + scoping interno en la función
    $(document).on("click", "#use-current-location, .use-current-location", function(e){
      e.preventDefault();
      getCurrentLocationClick($(this));
    });

    $(document).on("click", "#save-my-location, .save-my-location", function(e){
      e.preventDefault();
      const $container = $(this).closest('.custom-tooltip-trigger-container');
      saveCurrentLocation($container.find("#new-zip, .new-zip").val(), $(this));
    });

    $(document).on("click", ".action__custom__open__mobil", function(e){
        e.preventDefault();
        $("header-drawer summary").trigger("click");
    });

    // Scroll a un contenedor preferente (mob si existe, si no desk) y enfoca el input local
    $(document).on("click", ".go-to-location", function(e){
      e.preventDefault();
      const $pref = $(".custom-tooltip-trigger-container.mob").first().length 
                    ? $(".custom-tooltip-trigger-container.mob").first()
                    : $(".custom-tooltip-trigger-container.desk").first();
      if ($pref.length) {
        $('html, body').animate({ scrollTop: 0 }, 0, function() {
          $pref.find('.custom-tooltip').fadeIn(150);
          $pref.find('#new-zip, .new-zip').val('').focus(); 
          $pref.trigger("click");
        });
      }
    });

    $(document).on("click", ".custom-tooltip-trigger-s", function(e){
      e.preventDefault();
    });

   

    if ($('body').hasClass('product')) {
        let $p = $('body.product #shopify-section-template--19926715826421__section_UxpCid > .section > .custom-section-content > div > div:nth-child(2) > div:nth-child(2) > div:nth-child(1) > div:nth-child(2) p');
        
        if ($p.text().trim().length < 5) {
            $('body.product #shopify-section-template--19926715826421__section_UxpCid > .section > .custom-section-content > div > div:nth-child(2)').remove();
        }

        const $el = $(".text-block--AeU45NVRMTzFZRENVU__text_RLPyHy .metafield-multi_line_text_field");
        const originalText = $el.text().trim();
        if (!originalText) return;

        const words = originalText.split(/\s+/);

        // Asegúrate que el line-height sea numérico en px o em resoluble
        const lhCss = getComputedStyle($el[0]).lineHeight;
        const lineHeight = lhCss.endsWith('px') ? parseFloat(lhCss) : $el[0].getBoundingClientRect().height || 20;

        // Clon para medir con el MISMO ancho y estilos que el contenedor final
        const $clone = $el.clone().css({
        position: "absolute",
        visibility: "hidden",
        height: "auto",
        width: $el.width(),          // mismo ancho
        paddingLeft: $el.css('padding-left'), // mismo gutter reservado
        boxSizing: $el.css('box-sizing'),
        }).appendTo(document.body);

        // Medición: detectamos cuando aumenta el número de líneas reales
        let temp = "";
        let prevLines = 1;
        let parts = [];

        for (let i = 0; i < words.length; i++){
        const probe = (temp ? (temp + " ") : "") + words[i];
        $clone.text(probe);

        const h = $clone.height();
        const lines = Math.round(h / lineHeight);

        if (lines > prevLines && temp){   // se partió la línea
            parts.push(temp);
            temp = words[i];
            $clone.text(temp);
            prevLines = Math.round($clone.height() / lineHeight);
        } else {
            temp = probe;
            prevLines = lines;
        }
        }

        // última línea pendiente
        if (temp) parts.push(temp);

        // limpiar y pintar
        $clone.remove();
        $el.empty();

        // Render: asignamos un índice de línea --i para colocar el ícono sin afectar el wrap
        parts.forEach((line, idx) => {
        $el.append(`<span class="line-dot" style="--i:${idx}">${line}</span>`);
        });


    }
});

(function ($) {

  // Abrir / toggle
  $(document).on('click', '.custom-tooltip-trigger-s.open-area', function (e) {
    e.preventDefault();
    e.stopPropagation();

    var $wrap = $(this).closest('.custom-support-container');

    // quita el "force close" para permitir abrir otra vez
    $wrap.removeClass('force-closed');

    // (opcional) cierra otros
    $('.custom-support-container').not($wrap).removeClass('is-open force-closed');

    $wrap.toggleClass('is-open');
  });

  // Cerrar con X
  $(document).on('click', '.custom-support-container .close-panel', function (e) {
    e.preventDefault();
    e.stopPropagation();

    var $wrap = $(this).closest('.custom-support-container');

    // cierra y fuerza oculto (para que no lo vuelva a mostrar el :hover)
    $wrap.removeClass('is-open').addClass('force-closed');
  });

  // Click afuera cierra
  $(document).on('click', function () {
    $('.custom-support-container.is-open').removeClass('is-open').addClass('force-closed');
  });

  // Si el mouse sale del contenedor, ya permitimos hover otra vez
  $(document).on('mouseleave', '.custom-support-container', function () {
    $(this).removeClass('force-closed');
  });

})(jQuery);

